import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Navigation from "./components/parent/Navigation";
import "antd/dist/antd.min.css";
import "./styles/main.scss";
import Loader from "./components/mini/Loader";
import { getBlogsAPI } from "./api/GetBlogs";
import { blogsLoginAPI, coreUserAPI } from "./api/Auth";
import { useAuthStore } from "./store/AuthStore";

function App() {
  const dispatch = useDispatch();
  const { setAuthData } = useAuthStore();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    coreUserAPI()
      .then((core) => {
        console.log("INIT > coreUserAPI: ", core);
        if (core) {
          const coreToken = core.token;
          mainLogin(coreToken);
        }
      })
      .catch((err) => {
        console.log("INIT > coreUserAPI: ", err);
        setIsLoading(false);
      });
  }, []);

  const mainLogin = async (coreKey) =>
    blogsLoginAPI({ key: coreKey }).then(({ data: res }) => {
      localStorage.setItem("BlogsConsumerToken", res.token);
      localStorage.setItem("BlogsConsumerUser", JSON.stringify(res));

      if (res.role === "physician") {
        fetchDefaultBlog(res);
        return;
      }

      let payload = {
        userData: res,
        isLoggedIn: true,
        isPhysician: false,
        hasBlog: false,
        mainBlogId: null,
        blogData: null,
        isVerified: true,
      };

      setAuthData(payload);
      //TO REMOVE
      dispatch({
        type: "SET_USER_DATA",
        payload: payload,
      });

      setIsLoading(false);
    });

  const fetchDefaultBlog = useCallback(async (user) => {
    await getBlogsAPI(1, 1, "published", "", "", "", "", user.id)
      .then(({ blogs }) => {
        let payload = {
          userData: user,
          isLoggedIn: true,
          isPhysician: true,
        };

        // No Blog Found
        if (blogs.length === 0) {
          payload = {
            ...payload,
            hasBlog: false,
            mainBlogId: null,
            blogData: null,
            isVerified: true,
          };

          setAuthData(payload);
          //TO REMOVE
          dispatch({
            type: "SET_USER_DATA",
            payload: payload,
          });
          return;
        }

        // Blog Found
        const currBlog = blogs[0];
        payload = {
          ...payload,
          hasBlog: true,
          mainBlogId: currBlog.id,
          blogData: currBlog,
          isVerified: true,
        };

        setAuthData(payload);
        //TO REMOVE
        dispatch({
          type: "SET_USER_DATA",
          payload: payload,
        });
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const user = localStorage.getItem("BlogsConsumerUser");

    if (user && user !== "undefined") {
      const currentUser = JSON.parse(user);

      if (currentUser.role === "physician") {
        fetchDefaultBlog(currentUser);
        return;
      }

      setAuthData({
        hasBlog: false,
        isLoggedIn: true,
        mainBlogId: null,
        blogData: null,
        isPhysician: false,
        userData: currentUser,
        isVerified: true,
      });
    }

    setIsLoading(false);
  }, [fetchDefaultBlog]);

  if (isLoading)
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );

  return <Navigation />;
}

export default App;
